import React from "react";

type PrettyTitleProps = {
    /** Boş/undefined SSR veya eksik blok verisinde güvenli işlenir */
    title?: string | null;
    tag : string;
    className?: string;
    firstLineWords?: number;
    keepLastWords?: number;
    clampLines?: 1 | 2 | 3;
    strictOnMobile?: boolean;
    /** İki kelimelik başlıkları 2 satıra bölme:
     *  - 'always' => her breakpoint’te 2 satır
     *  - 'md' | 'lg' | 'xl' => o breakpointten itibaren 2 satır
     *  - false => bölme
     */
    twoWordBreakAt?: 'always' | 'md' | 'lg' | 'xl' | false;
};

export default function PrettyTitle({
                                        title,
                                        tag,
                                        className = '',
                                        firstLineWords = 2,
                                        keepLastWords = 2,
                                        clampLines = 2,
                                        strictOnMobile = false,
                                        twoWordBreakAt = 'always', // <— Figma gibi görünmesi için varsayılan hep ayır
                                    }: PrettyTitleProps) {
    const TitleTag = tag as React.ElementType;
    const words = String(title ?? '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    const firstCount = Math.min(firstLineWords, Math.max(1, words.length - 1));
    let lastCount  = Math.min(keepLastWords, Math.max(1, words.length - firstCount));
    if (firstCount + lastCount > words.length) {
        lastCount = Math.max(1, words.length - firstCount);
    }

    const first  = words.slice(0, firstCount).join(' ');
    const middle = words.slice(firstCount, words.length - lastCount).join(' ');
    const last   = words.slice(words.length - lastCount).join(' ');

    const nowrapClass = strictOnMobile
        ? 'whitespace-nowrap'
        : 'whitespace-normal md:whitespace-nowrap';

    // ——— iki kelime senaryosu (ör. first=1, last=1, middle boş) ———
    const isTwoWords = !middle && first && last;

    // hangi breakpoint’te bloklanacağını seç
    const displayForTwoWords =
        twoWordBreakAt === 'always' ? ['block', 'block'] :
            twoWordBreakAt === 'md'     ? ['inline md:block', 'inline md:block'] :
                twoWordBreakAt === 'lg'     ? ['inline lg:block', 'inline lg:block'] :
                    twoWordBreakAt === 'xl'     ? ['inline xl:block', 'inline xl:block'] :
                        ['inline', 'inline']; // false

    const firstSpanClass = (isTwoWords ? displayForTwoWords[0] : 'inline') + ' ' + nowrapClass;
    const lastSpanClass  = (isTwoWords ? displayForTwoWords[1] : 'inline') + ' ' + nowrapClass;

    return (
        <TitleTag data-prop-path="title" className={`uppercase leading-tight tracking-[0.08em] text-pretty line-clamp-${clampLines} ${className}`}>
            <span className={firstSpanClass}>{first}</span>
            {middle ? <> {' '}{middle}{' '} </> : ' '}
            <span className={lastSpanClass}>{last}</span>
        </TitleTag>
    );
}
